import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import LabeledInput from 'modules/core/components/LabeledInput'
import i18n from 'modules/core/lib/i18n'

import ChildrenItem from 'modules/job_catalog/components/NodeModal/ChildrenItem'

interface Props {
  onChange: (levels: string[]) => void
  type: string
}

const ChildrenInput: React.FC<Props> = ({ onChange, type }) => {
  const [children, setChildren] = React.useState<string[]>([])

  const items = children.map((_, i) => {
    const handleDelete = () => {
      const nextChildren = children.filter((__, ii) => i !== ii)

      setChildren(nextChildren)
      onChange(nextChildren)
    }

    const handleChange = (change: string) => {
      const nextChildren = children.slice()
      nextChildren[i] = change

      setChildren(nextChildren)
      onChange(nextChildren.filter((x) => x.trim() !== ''))
    }

    return <ChildrenItem key={i} onChange={handleChange} onDelete={handleDelete} />
  })

  const handleAddChildren = () => {
    setChildren([...children, ''])
  }

  return (
    <Box paddingBottom="s24">
      <LabeledInput label={`${type}s`} isLegend>
        {items.length > 0 ? items : <Box paddingBottom="s16" gap="s8" />}
        <Button onClick={handleAddChildren} type="secondary" iconName="add">
          {i18n.t('job_catalog.nodes.modal.add_children', { type })}
        </Button>
      </LabeledInput>
    </Box>
  )
}

export default ChildrenInput
